import React, { useEffect, useState } from 'react';
import { makeRequest } from '../../utils/httpRequest';
import Config from '../../core/config';
import ListPageLayout from '../common/ListPageLayout';

const apiUrl = Config.apiUrl;

const parseUtc = (iso) => new Date(iso + 'Z');

const formatLocal = (iso) => parseUtc(iso).toLocaleString('pt-BR', {
    day: '2-digit', month: '2-digit', year: 'numeric',
    hour: '2-digit', minute: '2-digit',
});

const loginAge = (iso) => {
    if (!iso) return null;
    const then = parseUtc(iso);
    const diffMs = Date.now() - then.getTime();
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffDays === 0) return 'hoje';
    if (diffDays === 1) return 'ontem';
    return `há ${diffDays} dias`;
};

const LoginBadge = ({ lastLoginAt }) => {
    if (!lastLoginAt) {
        return <span style={{ color: 'var(--color-text-secondary)', fontStyle: 'italic', fontSize: '12px' }}>Nunca</span>;
    }
    const diffDays = Math.floor((Date.now() - parseUtc(lastLoginAt).getTime()) / 86400000);

    let color = '#2e7d32';
    if (diffDays > 30) color = '#c62828';
    else if (diffDays > 7) color = '#e65100';

    return (
        <div>
            <div style={{ fontSize: '13px' }}>{formatLocal(lastLoginAt)}</div>
            <div style={{ fontSize: '11px', color, marginTop: '1px' }}>{loginAge(lastLoginAt)}</div>
        </div>
    );
};

const SummaryCard = ({ label, value, sub }) => (
    <div style={{
        background: 'var(--color-bg-panel)',
        border: '1px solid var(--color-border)',
        borderRadius: '10px',
        padding: '14px 20px',
        minWidth: '130px',
    }}>
        <div style={{ fontSize: '11px', color: 'var(--color-text-secondary)', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: '6px' }}>{label}</div>
        <div style={{ fontSize: '26px', fontWeight: 700, color: 'var(--color-text-heading)' }}>{value}</div>
        {sub && <div style={{ fontSize: '11px', color: 'var(--color-text-secondary)', marginTop: '2px' }}>{sub}</div>}
    </div>
);

const SystemUsageDashboard = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const [query, setQuery] = useState('');

    useEffect(() => {
        makeRequest(`${apiUrl}/api/system-usage-dashboard`, 'GET')
            .then(setData)
            .catch(() => setError('Erro ao carregar dados.'));
    }, []);

    if (error) return <p style={{ color: 'var(--semantic-error-text)', padding: '16px' }}>{error}</p>;
    if (!data) return <p style={{ padding: '16px' }}>Carregando...</p>;

    const { items, totalUsers, usersWithLogin, usersNeverLoggedIn } = data;

    const filtered = query.trim()
        ? items.filter(u =>
            u.name?.toLowerCase().includes(query.toLowerCase()) ||
            u.email?.toLowerCase().includes(query.toLowerCase()) ||
            u.companyName?.toLowerCase().includes(query.toLowerCase())
        )
        : items;

    return (
        <ListPageLayout
            tableWidth={700}
            header={<div className="header-label">Dashboard de Utilização</div>}
            filters={
                <input
                    type="text"
                    placeholder="Filtrar por usuário, e-mail ou empresa..."
                    value={query}
                    onChange={e => setQuery(e.target.value)}
                    style={{ width: '280px' }}
                />
            }
        >
            <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '20px' }}>
                <SummaryCard label="Total de usuários" value={totalUsers} />
                <SummaryCard label="Já fizeram login" value={usersWithLogin} sub={`${Math.round((usersWithLogin / totalUsers) * 100) || 0}% do total`} />
                <SummaryCard label="Nunca logaram" value={usersNeverLoggedIn} />
            </div>

            <table>
                <thead>
                    <tr>
                        <th>Usuário / Empresa</th>
                        <th>E-mail</th>
                        <th>Último login</th>
                    </tr>
                </thead>
                <tbody>
                    {filtered.map(u => (
                        <tr key={u.id}>
                            <td>
                                <div style={{ fontWeight: 500, fontSize: '14px' }}>
                                    {u.name}
                                    {u.adminUser && (
                                        <span style={{
                                            marginLeft: '6px',
                                            fontSize: '10px',
                                            background: 'var(--palette-blue)',
                                            color: '#fff',
                                            borderRadius: '4px',
                                            padding: '1px 5px',
                                            verticalAlign: 'middle',
                                        }}>admin</span>
                                    )}
                                </div>
                                <div style={{ fontSize: '12px', color: 'var(--color-text-secondary)', marginTop: '2px' }}>
                                    {u.companyName}
                                </div>
                            </td>
                            <td style={{ fontSize: '13px', color: 'var(--color-text-secondary)' }}>{u.email}</td>
                            <td><LoginBadge lastLoginAt={u.lastLoginAt} /></td>
                        </tr>
                    ))}
                </tbody>
                {filtered.length === 0 && (
                    <tfoot><tr><td colSpan={3}>Nenhum usuário encontrado.</td></tr></tfoot>
                )}
            </table>
        </ListPageLayout>
    );
};

export default SystemUsageDashboard;
